/**
 * LP graph (same behaviour as sections/lp-graph.liquid) for connection-successful modal step 9.
 * Exposes window.csModalLpGraphStep9.start(stepEl, { onComplete }) for staged title/footer (see modal liquid).
 */
(function () {
  'use strict';

  var g = 'cs-modal-step9';
  var id = 'lp-graph-svg-' + g;
  var idLine = 'lp-chartLine-' + g;
  var idArea = 'lp-chartArea-' + g;
  var idCol = 'lp-suppCol-' + g;
  var PTS = [
    [107, 687],
    [275, 623],
    [445, 548],
    [611, 450],
    [780, 351],
    [952, 231],
    [1112, 127],
    [1276, 66]
  ];
  var AXIS_Y = 782;
  /** Longest motion: line draw ~2.45s + small buffer before title/footer sequence */
  var ANIM_COMPLETE_MS = 2800;
  var activeCompleteTimer = null;

  function buildPath(pts) {
    var d = 'M ' + pts[0][0] + ' ' + pts[0][1];
    var n = pts.length;
    for (var i = 0; i < n - 1; i++) {
      var p0 = pts[Math.max(0, i - 1)];
      var p1 = pts[i];
      var p2 = pts[i + 1];
      var p3 = pts[Math.min(n - 1, i + 2)];
      var cp1x = p1[0] + (p2[0] - p0[0]) / 6;
      var cp1y = p1[1] + (p2[1] - p0[1]) / 6;
      var cp2x = p2[0] - (p3[0] - p1[0]) / 6;
      var cp2y = p2[1] - (p3[1] - p1[1]) / 6;
      d +=
        ' C ' +
        cp1x.toFixed(2) +
        ' ' +
        cp1y.toFixed(2) +
        ', ' +
        cp2x.toFixed(2) +
        ' ' +
        cp2y.toFixed(2) +
        ', ' +
        p2[0] +
        ' ' +
        p2[1];
    }
    return d;
  }

  function ensurePathsBuilt(svg, chartLine, chartArea, suppCol) {
    if (!svg || !chartLine || !chartArea) return;
    if (svg.getAttribute('data-cs-lp-paths') === '1') return;
    var linePath = buildPath(PTS);
    var last = PTS[PTS.length - 1];
    var first = PTS[0];
    var areaPath = linePath + ' L ' + last[0] + ' ' + AXIS_Y + ' L ' + first[0] + ' ' + AXIS_Y + ' Z';
    chartLine.setAttribute('d', linePath);
    chartArea.setAttribute('d', areaPath);

    svg.querySelectorAll('.bar').forEach(function (bar) {
      var bx = bar.getAttribute('data-x');
      bar.style.transformOrigin = bx + 'px ' + AXIS_Y + 'px';
    });
    svg.querySelectorAll('.dot-grp').forEach(function (gEl) {
      var cx = gEl.getAttribute('data-cx');
      var cy = gEl.getAttribute('data-cy');
      gEl.style.transformOrigin = cx + 'px ' + cy + 'px';
    });
    if (suppCol) suppCol.style.transformOrigin = '782px 782px';
    svg.setAttribute('data-cs-lp-paths', '1');
  }

  var xlink = 'http://www.w3.org/1999/xlink';
  function applyPillImagesFromWindow(svg) {
    var p = window.pills;
    if (!p || !svg) return;
    svg.querySelectorAll('image.pill-img[data-pill]').forEach(function (el) {
      var k = el.getAttribute('data-pill');
      if (k && p[k]) {
        el.setAttribute('href', p[k]);
        el.setAttributeNS(xlink, 'xlink:href', p[k]);
      }
    });
  }

  function bindPills(svg) {
    if (window.pills) {
      applyPillImagesFromWindow(svg);
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        applyPillImagesFromWindow(svg);
      });
    } else {
      applyPillImagesFromWindow(svg);
    }
  }

  window.csModalLpGraphStep9 = {
    cancelPending: function () {
      if (activeCompleteTimer) {
        clearTimeout(activeCompleteTimer);
        activeCompleteTimer = null;
      }
    },
    start: function (stepEl, options) {
      if (activeCompleteTimer) {
        clearTimeout(activeCompleteTimer);
        activeCompleteTimer = null;
      }
      var onComplete = options && options.onComplete;
      var svg = document.getElementById(id);
      if (!svg) {
        if (onComplete) onComplete();
        return;
      }
      var chartLine = document.getElementById(idLine);
      var chartArea = document.getElementById(idArea);
      var suppCol = document.getElementById(idCol);
      ensurePathsBuilt(svg, chartLine, chartArea, suppCol);
      bindPills(svg);

      svg.classList.remove('is-visible');
      if (chartLine) chartLine.classList.remove('is-visible');

      var completed = false;
      var completeTimer = null;
      var kicked = false;
      function done() {
        if (completed) return;
        completed = true;
        if (completeTimer) {
          clearTimeout(completeTimer);
          completeTimer = null;
        }
        activeCompleteTimer = null;
        if (onComplete) onComplete();
      }

      function kickVisible() {
        if (kicked || completed) return;
        kicked = true;
        svg.classList.add('is-visible');
        if (chartLine) chartLine.classList.add('is-visible');
        completeTimer = setTimeout(done, ANIM_COMPLETE_MS);
        activeCompleteTimer = completeTimer;
      }

      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.target === svg) {
              kickVisible();
              obs.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      obs.observe(svg);

      requestAnimationFrame(function () {
        var r = svg.getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) {
          kickVisible();
          try {
            obs.disconnect();
          } catch (e) {}
        }
      });

      if (svg.getAttribute('data-cs-lp-dbl') !== '1') {
        svg.setAttribute('data-cs-lp-dbl', '1');
        svg.addEventListener(
          'dblclick',
          function () {
            if (!chartLine) return;
            chartLine.style.transition = 'none';
            chartLine.classList.remove('is-visible');
            svg.classList.remove('is-visible');
            void chartLine.getBoundingClientRect();
            chartLine.style.removeProperty('transition');
            void svg.offsetWidth;
            svg.classList.add('is-visible');
            requestAnimationFrame(function () {
              chartLine.classList.add('is-visible');
            });
          },
          { passive: true }
        );
      }
    }
  };
})();
